import { Epic, combineEpics } from 'redux-observable';
import { isOfType, action } from 'typesafe-actions';
import { filter, mergeMap, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { toastr } from 'react-redux-toastr';

import { IRootAction, IRootState } from 'reducers';
import { ActionTypes } from 'reducers/cart';

import * as cartAPI from 'api/regRequest';

const addOrUpdate: Epic<IRootAction, any, IRootState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ActionTypes.CART_ADD_OR_UPDATE)),
    mergeMap<any, any>(({ payload }) => {
      const currentProducts = state$.value.cart.products;
      const foundInCart = currentProducts.find(i => i.product_id === payload.product_id && i.car_classes_id === payload.car_classes_id);

      // Добавление в корзину
      if (!foundInCart) {
        return of(action(ActionTypes.CART_PRODUCT_ADD, payload));
      }

      // Изменение кол-ва и класса у уже добавленного товара
      return of(
        action(
          ActionTypes.CART_PRODUCT_UPDATE,
          {
            no: foundInCart.no,
            car_classes_id: payload.car_classes_id,
            quantity: foundInCart.quantity + payload.quantity,
          },
        ),
      );
    }),
);

const addToCart: Epic<IRootAction, any> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ActionTypes.CART_PRODUCT_ADD)),
    mergeMap<any, any>(({ payload }) =>
      from(cartAPI.addProductToCart(payload)).pipe(
        mergeMap<any, any>((response: any) => {
          if (response.success) {
            toastr.success('Продукт добавлен в корзину' , '');
            return of(
              action(ActionTypes.CART_PRODUCT_ADD_SUCCESS, response.data),
            );
          }
          toastr.error(response.error, '');
          return of(
            action(ActionTypes.CART_PRODUCT_ADD_FAILURE),
          );
        }),
        catchError(error => {
          return of(`Error: ${error}`, action(ActionTypes.CART_PRODUCT_ADD_FAILURE))
        })
      )
    ),
  );

const updateInCart: Epic<IRootAction, any> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ActionTypes.CART_PRODUCT_UPDATE)),
    mergeMap<any, any>(({ payload }) =>
      from(cartAPI.updateProductInCart(payload)).pipe(
        mergeMap<any, any>((response: any) => {
          if (response.success) {
            toastr.success('Обновление кол-ва продукта' , '');
            return of(
              action(ActionTypes.CART_PRODUCT_UPDATE_SUCCESS, payload),
            );
          }
          toastr.error(response.error, '');
          return of(
            action(ActionTypes.CART_PRODUCT_UPDATE_FAILURE),
          );
        }),
        catchError(error => {
          return of(`Error: ${error}`, action(ActionTypes.CART_PRODUCT_UPDATE_FAILURE))
        })
      )
    ),
  );

  const deleteFromCart: Epic<IRootAction, any> = (action$, state$) =>
    action$.pipe(
      filter(isOfType(ActionTypes.CART_PRODUCT_DELETE)),
      mergeMap<any, any>(({ payload }) =>
        from(cartAPI.deleteFromCart(payload)).pipe(
          mergeMap<any, any>((response: any) => {
            if (response.success) {
              toastr.success('Продукт удален из корзины' , '');
              return of(
                action(ActionTypes.CART_PRODUCT_DELETE_SUCCESS, payload),
              );
            }
            toastr.error(response.error, '');
            return of(
              action(ActionTypes.CART_PRODUCT_DELETE_FAILURE),
            );
          }),
          catchError(error => {
            return of(`Error: ${error}`, action(ActionTypes.CART_PRODUCT_DELETE_FAILURE))
          })
        )
      ),
    );

export default combineEpics(
  addOrUpdate,
  addToCart,
  updateInCart,
  deleteFromCart,
);
